import React, { useEffect } from 'react'
import queryString from 'query-string'
import { Form } from './Form'
import {
  Switch,
  Route,
  useLocation
} from 'react-router-dom'
import { createAuthProvider } from '../shared/providers/auth'

export default () => {
  const location = useLocation()
  const authProvider = createAuthProvider()

  useEffect(() => {
    const params = queryString.parse(location.search)

    if (params?.token) {
      authProvider.saveToken(params.token as string)
    }
  }, [authProvider, location])

  return (
    <Switch>
      <Route path='/' exact>
        <Form />
      </Route>

      <Route path='/contracts/:id/new-form'>
        <Form />
      </Route>
    </Switch>
  )
}
